export enum AcceptTypes {
  Csv = 'text/csv',
}

export enum RequestMethods {
  Get = 'get',
  Post = 'post',
}
